/**
 *
 * Take items of an array while they fulfill a predicate.
 *
 * 	takeWhile(i => i % 2 === 0, [2, 4, 6, 8, 7, 8, 8]); // => [2, 4, 6, 8]
 *
 */
export default function takeWhile(arr, pred) {
    return arr.reduce((newArr, i) => {
        if (!pred(i)) {
            arr.length = 0;
        } else {
            newArr.push(i);
        }
        return newArr;
    }, []);
}


// WEBPACK FOOTER //
// ./app/shared/takeWhile.js